import { http } from "./http";

async function signIn(username, password) {
  const response = await http({
    url: "/token",
    method: "post",
    data: "grant_type=password&username=" + username + "&password=" + password,
    headers: {
      "Content-type": "application/x-www-form-urlencoded",
    },
  });
  return {
    accessToken: response.data.access_token,
    refreshToken: response.data.refresh_token,
    expiresIn: response.data.expires_in,
  };
}

async function getCurrentUser() {
  const response = await http.get("users/current");
  return {
    id: response.data.Id,
    name: response.data.Username,
    title: response.data.Title,
    roles: response.data.Roles.map(role => {
      return {
        id: role.Id,
        title: role.Title,
      };
    }),
    isClient: response.data.IsClient ? true : false,
    avatar: response.data.Avatar ? response.data.Avatar : null,
    hasEmployee: response.data.HasEmployee,
    employeeId: response.data.EmployeeId,
  };
}

export { signIn, getCurrentUser };
